module.exports = __webpack_public_path__ + "img/success.56143b5f.png";